export enum Role {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3
}
